export default () => {
  return {
    presets: ['next/babel'],
    plugins: [],
  };
};
